import React from 'react';

/**
 * @function MailLink
 * @param {string|null} to
 * @return {JSX.Element}
 * @constructor
 */
const MailLink = ({to}) => {
    if (!to) {
        to = process.env.MIX_APP_MAIL;
    }

    return (
        <a
            href={`mailto:${to}`}
            className="underline cursor-pointer"
        >
            {to}
        </a>
    );
};

export default MailLink;
